import pick from 'lodash/pick'

import { reducer as formReducer } from 'redux-form'

import {
  reducer as SimpleFetchManagerDetails,
  constants as SimpleFetchManagerConstants,
} from 'loankeeper-common/helpers/SimpleFetchManager'

import common from './common'

import { logout } from '../store/auth'

import { reducer as ClientForm, constants as ClientFormConstants } from '../features/ClientForm'
import { reducer as DetailsContainer, constants as DetailsContainerConstants } from '../features/DetailsContainer'

import { reducer as TabSlider, constants as TabSliderConstants } from '../features/DetailsContainer/Tabs/TabSlider'

import { reducer as LKGrid, REDUCER_NAME as LK_GRID_REDUCER_NAME } from '../features/shared/LKGrid'
import { reducer as FileDetails, constants as FileDetailsConstants } from '../features/FileDetails'
import { reducer as FilesGrid, constants as FilesGridConstants } from '../features/FilesGrid'
import { reducer as ConditionAdd, constants as ConditionAddConstants } from '../features/ConditionAdd'
import { reducer as LoanOfficerAdd, constants as LoanOfficerAddConstants } from '../features/LoanOfficerAdd'

import { reducer as LKModal, REDUCER_NAME as LK_MODALS_REDUCER_NAME } from '../features/shared/LKModal'
import { reducer as LKPrintButton, constants as LKPrintButtonConstants } from '../features/shared/LKPrintButton'

import {
  reducer as ApplicationFactory,
  constants as ApplicationFactoryConstants,
} from '../features/shared/ApplicationFactory'
import { reducer as Reporting, constants as ReportingConstants } from '../features/Reporting'

// LoanDetail features here
import {
  reducer as LoanOperations,
  constants as LoanOperationConstants,
} from '../features/LoanDetails/Info/OperationsTransactions'
import { reducer as LoanSchedule, constants as LoanScheduleConstants } from '../features/LoanDetails/Info/Schedule'
import {
  reducer as LoanReminders,
  constants as LoanRemindersConstants,
} from '../features/LoanDetails/Info/Notes/Reminders'

// ClientDetail features here
import {
  reducer as CivilRegistry,
  constants as CivilRegistryConstants,
} from '../features/ClientDetails/Tabs/CivilRegistry'

import { reducer as CollateralDetails, constants as CollateralDetailConstants } from '../features/CollateralDetails'

export const legacyReducers = {
  form: formReducer,
  common,
  [ClientFormConstants.REDUCER_NAME]: ClientForm,
  [DetailsContainerConstants.REDUCER_NAME]: DetailsContainer,

  [TabSliderConstants.REDUCER_NAME]: TabSlider,

  [LK_GRID_REDUCER_NAME]: LKGrid,
  [FileDetailsConstants.REDUCER_NAME]: FileDetails,
  [FilesGridConstants.REDUCER_NAME]: FilesGrid,
  [ConditionAddConstants.REDUCER_NAME]: ConditionAdd,
  [LoanOfficerAddConstants.REDUCER_NAME]: LoanOfficerAdd,
  [ReportingConstants.REDUCER_NAME]: Reporting,

  [LK_MODALS_REDUCER_NAME]: LKModal,
  [LKPrintButtonConstants.REDUCER_NAME]: LKPrintButton,

  // LoanDetail features here
  [LoanOperationConstants.REDUCER_NAME]: LoanOperations,
  [LoanScheduleConstants.REDUCER_NAME]: LoanSchedule,
  [LoanRemindersConstants.REDUCER_NAME]: LoanReminders,

  // ClientDetail features here
  [CivilRegistryConstants.REDUCER_NAME]: CivilRegistry,

  // CollateralDetail features here
  [CollateralDetailConstants.REDUCER_NAME]: CollateralDetails,

  [SimpleFetchManagerConstants.REDUCER_NAME]: SimpleFetchManagerDetails,

  [ApplicationFactoryConstants.REDUCER_NAME]: ApplicationFactory,
}

export function legacyRootReducer(state, action, newReducers) {
  let newState = state

  if (logout.fulfilled.match(action)) {
    newState = {
      config: state.config,
      persisted: state.persisted,
      form: pick(state.form, ['loginForm']),
      auth: state.auth,
    }
  } else if (logout.rejected.match(action)) {
    newState = {
      persisted: state.persisted,
    }
  }

  return newReducers(newState, action)
}
